import { UseFormRegister, get } from 'react-hook-form';

/**
 * テキストフィールド基本コンポーネント
 */
export default function FormDate(props: {
  // タイトル
  subject?: string;
  // name属性
  name: string;
  // プレースホルダー
  placeholder?: string;
  // 必須検証の有無
  required?: boolean;
  // 必須/任意のアイコン表示有無
  requiredMark?: boolean;
  // 読み取り専用
  readOnly?: boolean;
  // 最小値
  min?: Date;
  // 最大値
  max?: Date;
  // エラー情報
  errors: any;
  // クラス名
  className?: string;
  register: UseFormRegister<any>;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    // yyyy/MM/ddの形式に変換
    if (/^\d{4}$/.test(value)) {
      e.target.value = `${value}/`;
    } else if (/^\d{4}\/\d{2}$/.test(value)) {
      e.target.value = `${value}/`;
    } else if (/^\d{8}$/.test(value)) {
      e.target.value = `${value.substring(0, 4)}/${value.substring(4, 6)}/${value.substring(6, 8)}`;
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    const key = e.key;
    // バックスペースで '/' を削除するとき、1つ前の数字も削除する
    if (key === 'Backspace') {
      const cursorPosition = input.selectionStart || 0;
      const value = input.value;
      if (value[cursorPosition - 1] === '/') {
        e.preventDefault();
        input.value = value.slice(0, cursorPosition - 2) + value.slice(cursorPosition);
        setTimeout(() => {
          input.setSelectionRange(cursorPosition - 2, cursorPosition - 2);
        }, 0);
      }
    }
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数 */
  /* ----------------------------------------------------------------------- */
  const _isValidDate = (dateString: string) => {
    const [year, month, day] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);
    const isValid =
      date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
    return isValid;
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  // 検証タイプの取得
  const type = get(props.errors, props.name)?.type ?? null;
  return (
    <>
      {props.subject && (
        <label className="form-label">
          {props.subject}
          {props.requiredMark && (
            <span className={props.required ? 'must' : 'any'}>{props.required ? ' *' : ''}</span>
          )}
        </label>
      )}
      <input
        className={
          get(props.errors, props.name)
            ? `is-invalid form-control ${props.className}`
            : `form-control ${props.className}`
        }
        {...{ name: props.name }}
        readOnly={props.readOnly ? true : false}
        placeholder={props.placeholder}
        type={'text'}
        {...props.register(props.name, {
          required: props.required,
          pattern: {
            value: /^\d{4}\/\d{2}\/\d{2}$/,
            message: '1990/01/01の形式で入力してください。',
          },
          validate: value => {
            if (!_isValidDate(value)) {
              return '無効な日付です。';
            }
            const [year, month, day] = value.split('/').map(Number);
            const date = new Date(year, month - 1, day);
            if (props.min) {
              const minDate = props.min;
              if (date < minDate) {
                return `${minDate.getFullYear()}年${
                  minDate.getMonth() + 1
                }月${minDate.getDate()}日以前の日付は入力できません。`;
              }
            }
            if (props.max) {
              const maxDate = props.max;
              if (date >= maxDate) {
                return `${maxDate.getFullYear()}年${
                  maxDate.getMonth() + 1
                }月${maxDate.getDate()}日以降の日付は入力できません。`;
              }
            }
          },
          onChange: handleChange,
        })}
        inputMode="tel"
        onKeyDown={handleKeyDown}
      />
      {/* {get(props.errors, props.name) && ( */}
      {/* {props.errors[props.name] && ( */}
      {get(props.errors, props.name) && (
        <p className="error">
          {type === 'required' && <>必須項目です。</>}
          {get(props.errors, props.name)?.type === 'custom' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
          {get(props.errors, props.name)?.type === 'pattern' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
          {get(props.errors, props.name)?.type === 'validate' && (
            <>{get(props.errors, props.name)?.message}</>
          )}
        </p>
      )}
    </>
  );
}
